import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@material-ui/core';
import { accessHistoryApi } from 'api/authApi';
import { getHeadQuarterApi, getStoreSettingDetailApi, getStoreSettingStartTimeAndEndTimeApi } from 'api/onlineBookingV2Api';
import ScreenLoader from 'components/organismos/ScreenLoader';
import { DEFAULT_BOOKING_GAP_MINUTES, DEFAULT_INQUIRY_ACCEPT_PERIOD_MONTH_CODE } from 'constants/setting';
import moment from 'moment';
import useAppSnackbar from 'hooks/useAppSnackbar';
import BigButtonNext from 'pages/reservationBookingOnlineV2/components/BigButtonNext';
import SectionHeader from 'pages/reservationBookingOnlineV2/components/SectionHeader';
import { StatusBooking, useReservationBookingOnlineContext } from 'pages/reservationBookingOnlineV2/context';
import {
  filterTimesByBookingGap, formatDataInfoCustomer, getDesiredDateString, getInquiryDayOptions, getInquiryDeadlineTime, getInquiryMonthOptions, returnHistoryPath,
} from 'pages/reservationBookingOnlineV2/functions';
import { stringify } from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import handleError from 'utility/handleError';
import * as yup from 'yup';
import AgreeSection from './components/AgreeSection';
import FormElementDateSelect from './components/FormElementDateSelect';
import FormElementThreeDateSelect from './components/FormElementThreeDateSelect';
import FormElementWithCheckboxes from './components/FormElementWithCheckboxes';
import FormElementWithOneInput from './components/FormElementWithOneInput';
import FormElementWithOneTextArea from './components/FormElementWithOneTextArea';
import FormElementWithThreeInput from './components/FormElementWithThreeInput';
import FormElementWithTwoInput from './components/FormElementWithTwoInput';
import useStyles from './styles';
import { ICustomerInformation, ICustomerInformation2 } from './types';


const countCharacterInArray = (arr:any[], character: string | number = ''):number => (arr ? arr.filter((x) => x === character).length : 0);

interface IEnterCustomerInformation {
  companyCode:string,
  courseCode?:string,
  mediaCode?:string,
  gender?:string,
  serviceCode?:string,
  trackingCode?:string,
}

const renderQuarterHours = () => {
  const quarterHours = ['00', '15', '30', '45'];
  const times = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 24; i++) {
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < 4; j++) {
      times.push(`${i < 10 ? `0${i}` : i}:${quarterHours[j]}`);
    }
  }
  return times;
};
const defaultDesiredTime = renderQuarterHours();

const getTimeInString = (str:string) => {
  if (!str) { return ''; }
  const arr = str.split('T');
  const arrTime = arr[1].split(':');
  return (arrTime.length > 0 ? `${arrTime[0]}:${arrTime[1]}` : '');
};

const toMinutesOfDay = (hhmm:string):number => {
  const [hour, minute] = String(hhmm).split(':').map(Number);
  return (Number.isNaN(hour) || Number.isNaN(minute)) ? NaN : hour * 60 + minute;
};

const getListTimeFromTimeFromTime = (listTimeArr:string[] = [], time:{ startTime: string, endTime:string}) => {
  const startMinutes = toMinutesOfDay(getTimeInString(time?.startTime));
  const endMinutes = toMinutesOfDay(getTimeInString(time?.endTime));
  if (Number.isNaN(startMinutes) || Number.isNaN(endMinutes) || startMinutes === endMinutes) return [];
  if (startMinutes > endMinutes) {
    return listTimeArr.filter((item) => {
      const minutes = toMinutesOfDay(item);
      return minutes >= startMinutes || minutes < endMinutes;
    });
  }
  return listTimeArr.filter((item) => {
    const minutes = toMinutesOfDay(item);
    return minutes >= startMinutes && minutes < endMinutes;
  });
};

const EnterCustomerInformation: React.FC<IEnterCustomerInformation> = ({
  companyCode, courseCode, mediaCode, gender, serviceCode, trackingCode,
}) => {
  const history = useHistory();
  const { enqueueSnackbar } = useAppSnackbar();
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [isButtonNextDisable, setIsButtonNextDisable] = useState<boolean>(true);
  const [note, setNote] = useState<string>('');
  const [defaultDesiredTimeList, setDefaultDesiredTimeList] = useState<[string[], string[], string[]]>([defaultDesiredTime, defaultDesiredTime, defaultDesiredTime]);
  const [inquiryAcceptPeriodMonthCode, setInquiryAcceptPeriodMonthCode] = useState<string>(DEFAULT_INQUIRY_ACCEPT_PERIOD_MONTH_CODE);
  const [inquiryAcceptanceDeadline, setInquiryAcceptanceDeadline] = useState<string | null>(null);
  const [bookingGapMinutes, setBookingGapMinutes] = useState<number>(DEFAULT_BOOKING_GAP_MINUTES);
  const [desiredDayList, setDesiredDayList] = useState<[string[], string[], string[]]>([[], [], []]);
  const { handleChangeInfoCustomer, status, ...context } = useReservationBookingOnlineContext();
  const TITLE = (status === StatusBooking.AVAILABLE_BOOKING) ? '3. お客様情報の入力' : '3. お問い合わせフォーム（フォームからのお問合せだけでは予約確定とはなりませんのでご注意ください。）';
  const {
    customerFirstName, customerLastName, customerFirstNameNameInFurigawa,
    customerLastNameNameInFurigawa, customerBirthdayYear, customerBirthdayMonth, customerBirthdayDay, phoneNumber1, phoneNumber2, phoneNumber3,
    emailAddress, consultationOrRequest, isEmailNewsLetter, desiredMonth2, desiredDay2, desiredHour2, desiredMonth3, desiredDay3, desiredHour3,
    desiredTime, chosenStore, chosenStoreName, chosenCourse,
  } = context;
  const defaultValues = {
    customerFirstName,
    customerLastName,
    customerFirstNameNameInFurigawa,
    customerLastNameNameInFurigawa,
    customerBirthdayYear,
    customerBirthdayMonth,
    customerBirthdayDay,
    phoneNumber1,
    phoneNumber2,
    phoneNumber3,
    emailAddress,
    consultationOrRequest,
    isEmailNewsLetter,
  };

  const defaultValues2 = {
    ...defaultValues,
    desiredMonth1: String(moment(desiredTime, 'YYYY年MM月DD日 HH:mm').format('MM')),
    desiredDay1: String(moment(desiredTime, 'YYYY年MM月DD日 HH:mm').format('DD')),
    desiredHour1: String(moment(desiredTime, 'YYYY年MM月DD日 HH:mm').format('HH:mm')),
    desiredMonth2,
    desiredDay2,
    desiredHour2,
    desiredMonth3,
    desiredDay3,
    desiredHour3,
  };

  const validationSchema = yup.object().shape<ICustomerInformation>({
    customerFirstName: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('名を入力してください'),
    customerLastName: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('姓を入力してください'),
    customerFirstNameNameInFurigawa: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('めいを入力してください'),
    customerLastNameNameInFurigawa: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('せいを入力してください'),
    customerBirthdayYear: yup.string().required('を入力してください'),
    customerBirthdayMonth: yup.string().required('を入力してください'),
    customerBirthdayDay: yup.string().required('を入力してください'),
    phoneNumber1: yup.string().test('phoneNumber1', '半角数字で入力してください', (val) => (val ? (/^[0-9]+$/.test(val || '')) : true)).max(4, '最低4桁を入力してください')
      .when(['phoneNumber2', 'phoneNumber3'], {
        is: (val1, val2) => (Number(String(val1 || '').length + String(val2 || '').length) < 1),
        then: yup.string().test('phoneNumber1', 'お電話番号を入力してください', (val) => (String(val).length > 0)),
      }),
    phoneNumber2: yup.string().test('phoneNumber2', '半角数字で入力してください', (val) => (val ? (/^[0-9]+$/.test(val || '')) : true)).max(4, '最低4桁を入力してください'),
    phoneNumber3: yup.string().test('phoneNumber3', '半角数字で入力してください', (val) => (val ? (/^[0-9]+$/.test(val || '')) : true)).max(4, '最低4桁を入力してください'),
    consultationOrRequest: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(1000, '1000文字までご入力いただけます'),
    emailAddress: yup.string().max(100, '100文字までご入力いただけます').required('メールアドレスを入力してください').matches(/^[^='()（）＝’]+$/, "=, ' はお使いいただけません")
      .matches(/[a-zA-Z0-9]+[a-zA-Z0-9\\._-]*@[a-zA-Z0-9_-]+[a-zA-Z0-9\\._-]+/, 'メール形式が無効です'),
    isEmailNewsLetter: yup.string().required(),
  });

  const validationSchema2 = yup.object().shape<ICustomerInformation2>({
    customerFirstName: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('名を入力してください'),
    customerLastName: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('姓を入力してください'),
    customerFirstNameNameInFurigawa: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('めいを入力してください'),
    customerLastNameNameInFurigawa: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(20, '20文字までご入力いただけます').required('せいを入力してください'),
    customerBirthdayYear: yup.string().required('を入力してください'),
    customerBirthdayMonth: yup.string().required('を入力してください'),
    customerBirthdayDay: yup.string().required('を入力してください'),
    phoneNumber1: yup.string().test('phoneNumber1', '半角数字で入力してください', (val) => (val ? (/^[0-9]+$/.test(val || '')) : true)).max(4, '最低4桁を入力してください')
      .when(['phoneNumber2', 'phoneNumber3'], {
        is: (val1, val2) => (Number(String(val1 || '').length + String(val2 || '').length) < 1),
        then: yup.string().test('phoneNumber1', 'お電話番号を入力してください', (val) => (String(val).length > 0)),
      }),
    phoneNumber2: yup.string().test('phoneNumber2', '半角数字で入力してください', (val) => (val ? (/^[0-9]+$/.test(val || '')) : true)).max(4, '最低4桁を入力してください'),
    phoneNumber3: yup.string().test('phoneNumber3', '半角数字で入力してください', (val) => (val ? (/^[0-9]+$/.test(val || '')) : true)).max(4, '最低4桁を入力してください'),
    consultationOrRequest: yup.string().matches(/^[^='()（）＝’]*$/, "=, ' はお使いいただけません").max(1000, '1000文字までご入力いただけます'),
    emailAddress: yup.string().max(100, '100文字までご入力いただけます').required('メールアドレスを入力してください').matches(/^[^='()（）＝’]+$/, "=, ' はお使いいただけません")
      .matches(/[a-zA-Z0-9]+[a-zA-Z0-9\\._-]*@[a-zA-Z0-9_-]+[a-zA-Z0-9\\._-]+/, 'メール形式が無効です'),
    isEmailNewsLetter: yup.string().required('を入力してください'),
    desiredMonth1: yup.string(),
    desiredDay1: yup.string(),
    desiredHour1: yup.string(),
    desiredMonth2: yup.string(),
    desiredDay2: yup.string(),
    desiredHour2: yup.string(),
    desiredMonth3: yup.string(),
    desiredDay3: yup.string(),
    desiredHour3: yup.string(),
  }).test({
    name: 'desired2',
    exclusive: true,
    message: '日付の形式が正しくありません',
    test: (value) => {
      const count = countCharacterInArray([value?.desiredMonth2, value?.desiredDay2, value?.desiredHour2]);
      return (count === 0 || count === 3);
    },
  }).test({
    name: 'desired3',
    exclusive: true,
    message: '日付の形式が正しくありません',
    test: (value) => {
      const count = countCharacterInArray([value?.desiredMonth3, value?.desiredDay3, value?.desiredHour3]);
      return (count === 0 || count === 3);
    },
  });

  const validationSchema2WithDuplicateCheck = validationSchema2.test({
    name: 'desiredDuplicate',
    exclusive: true,
    message: '第二希望と第三希望に同じ日時が入力されています。異なる日時を入力してください。',
    test: (value) => {
      const second = [value?.desiredMonth2, value?.desiredDay2, value?.desiredHour2].join('');
      const third = [value?.desiredMonth3, value?.desiredDay3, value?.desiredHour3].join('');
      return !(second && second === third);
    },
  });

  const methods = useForm<ICustomerInformation2>({
    resolver: yupResolver((status === StatusBooking.CALL_BEFORE_BOOKING) ? validationSchema2WithDuplicateCheck : validationSchema),
    mode: 'onChange',
    defaultValues: (status === StatusBooking.CALL_BEFORE_BOOKING) ? defaultValues2 : defaultValues,
  });

  const { handleSubmit, getValues, setValue } = methods;

  const monthsToShow = useMemo(() => getInquiryMonthOptions(inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline), [inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline]);

  const onSubmit = (data: ICustomerInformation2) => {
    const infoCustomer = formatDataInfoCustomer(data);
    handleChangeInfoCustomer && handleChangeInfoCustomer(infoCustomer);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'reservation_info_entered',
      reservation_company_code: companyCode,
      reservation_org_id: chosenStore || '',
      reservation_org_name: chosenStoreName || '',
    });
    history.replace({
      search: returnHistoryPath(companyCode, 4, courseCode, mediaCode, gender, serviceCode, trackingCode),
    });
  };

  const handleChangeTimeByDate = async (month:string, day:string, index:number) => {
    try {
      if (month && day) {
        const targetDate = getDesiredDateString(month, day);
        const params: { orgId: string, targetDate: string, companyCode: string, contractCourseId?: string } = {
          orgId: chosenStore || '',
          targetDate,
          companyCode: companyCode || '',
        };
        if (chosenCourse) params.contractCourseId = chosenCourse;
        const res = await getStoreSettingStartTimeAndEndTimeApi(params);
        const { endTime, startTime } = res;
        let arrTime = getListTimeFromTimeFromTime(defaultDesiredTime, { endTime, startTime });
        arrTime = filterTimesByBookingGap(arrTime, getTimeInString(startTime), bookingGapMinutes);
        if (moment(targetDate, 'YYYY-MM-DD').isSame(moment(), 'day')) {
          const currentTime = moment().format('HH:mm');
          arrTime = arrTime.filter((item:string) => item > currentTime);
        }
        const deadlineTime = getInquiryDeadlineTime(inquiryAcceptanceDeadline);
        if (deadlineTime && moment(targetDate, 'YYYY-MM-DD').isSame(deadlineTime, 'day')) {
          arrTime = arrTime.filter((item:string) => moment(`${targetDate} ${item}`, 'YYYY-MM-DD HH:mm').isSameOrAfter(deadlineTime));
        }
        const arrTimeResult = arrTime;
        setDefaultDesiredTimeList((prev) => prev.map((item:string[], i:number) => (i === index ? arrTimeResult : item)) as [string[], string[], string[]]);
        const currentHour = getValues(`desiredHour${index + 1}`);
        if (currentHour && !arrTimeResult.includes(currentHour)) {
          setValue(`desiredHour${index + 1}`, '');
        }
      }
    } catch (error) {
      handleError({ error, enqueueSnackbar });
    }
  };

  const handleChangeDesiredMonth = (month:string, index:number) => {
    const dayOptions = getInquiryDayOptions(month, inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline);
    setDesiredDayList((prev) => prev.map((item:string[], i:number) => (i === index ? dayOptions : item)) as [string[], string[], string[]]);
    const currentDay = getValues(`desiredDay${index + 1}`);
    if (currentDay && !dayOptions.includes(currentDay)) {
      setValue(`desiredDay${index + 1}`, '');
      setValue(`desiredHour${index + 1}`, '');
    }
  };

  useEffect(() => {
    // Check accept page
    if (!desiredTime) {
      history.replace({
        search: returnHistoryPath(companyCode, 0, courseCode, mediaCode, gender, serviceCode, trackingCode),
      });
    }
    // Save history access screen
    try {
      setLoading(true);
      const paramsPost = { accessUrl: `${history?.location?.pathname + history?.location?.search}`, companyCode, staffId: '' };
      accessHistoryApi(paramsPost);
    } catch (error) {
      handleError({ error, enqueueSnackbar });
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!companyCode || !chosenStore || status !== StatusBooking.CALL_BEFORE_BOOKING) return;
    (async () => {
      try {
        const res = await getStoreSettingDetailApi({ orgId: chosenStore, companyCode });
        setInquiryAcceptPeriodMonthCode(res?.inquiryAcceptPeriodMonthCode ?? DEFAULT_INQUIRY_ACCEPT_PERIOD_MONTH_CODE);
        setInquiryAcceptanceDeadline(res?.inquiryAcceptanceDeadline ?? null);
        setBookingGapMinutes(Number(res?.bookingGapMinutes) || DEFAULT_BOOKING_GAP_MINUTES);
      } catch (error) {
        handleError({ error, enqueueSnackbar });
      }
    })();
  }, [companyCode, chosenStore, status, enqueueSnackbar]);

  useEffect(() => {
    const monthOptions = getInquiryMonthOptions(inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline);
    const nextDayList = [2, 3].map((no) => {
      const month = getValues(`desiredMonth${no}`);
      if (month && !monthOptions.includes(month)) {
        setValue(`desiredMonth${no}`, '');
        setValue(`desiredDay${no}`, '');
        setValue(`desiredHour${no}`, '');
        return [];
      }
      return getInquiryDayOptions(month, inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline);
    });
    setDesiredDayList([[], nextDayList[0], nextDayList[1]]);
  }, [inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline, getValues, setValue]);

  useEffect(() => {
    if (!companyCode || !chosenStore || status !== StatusBooking.CALL_BEFORE_BOOKING) return;
    [2, 3].forEach((no) => {
      const month = getValues(`desiredMonth${no}`);
      const day = getValues(`desiredDay${no}`);
      if (month && day) handleChangeTimeByDate(String(month), String(day), no - 1);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyCode, chosenStore, status, inquiryAcceptPeriodMonthCode, inquiryAcceptanceDeadline, bookingGapMinutes]);

  useEffect(() => {
    if (!companyCode) return;
    (async () => {
      try {
        const res = await getHeadQuarterApi(companyCode);
        setNote(res?.note ?? '');
      } catch (error) {
        handleError({ error, enqueueSnackbar });
      }
    })();
  }, [companyCode, enqueueSnackbar]);

  return (
    <ScreenLoader isLoading={isLoading}>
      <div className={classes.root}>
        <SectionHeader title={TITLE} />
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} className={classes.formOverall}>
            <FormElementWithTwoInput
              nameInput1="customerLastName"
              nameInput2="customerFirstName"
              labelInput="お名前"
              placeHolderInput1="姓"
              placeHolderInput2="名"
              autoFocus1={true}
            />
            <FormElementWithTwoInput
              nameInput1="customerLastNameNameInFurigawa"
              nameInput2="customerFirstNameNameInFurigawa"
              labelInput="ふりがな（全角かな）"
              placeHolderInput1="せい"
              placeHolderInput2="めい"
            />
            <FormElementDateSelect
              labelInput="生年月日"
            />
            <div className={classes.formNote}>
              <p className={classes.formNoteImportant}>
                未成年・学生の方は必ずご確認ください。
              </p>
              <p>
                ※未成年・学生の方は保護者に同伴いただくか、ご来店の際に親権者同意書をお持ちいただくか、保護者様へのお電話での確認が必要です。同意書は
                <a href="https://ci-z.com/wp-content/themes/ci-z/assets/pdf/side-pdf-01.pdf" style={{ color: '#cd0021' }} target="_blank" rel="noopener noreferrer">こちら</a>
                から。
              </p>
            </div>
            <FormElementWithThreeInput
              labelInput="お電話番号（半角数字）"
              nameInput1="phoneNumber1"
              nameInput2="phoneNumber2"
              nameInput3="phoneNumber3"
            />
            <FormElementWithOneInput
              nameInput="emailAddress"
              labelInput="メールアドレス（半角英数字）"
            />
            {(status === StatusBooking.CALL_BEFORE_BOOKING) && (
            <FormElementThreeDateSelect
              handleChangeTimeByDate={handleChangeTimeByDate}
              handleChangeDesiredMonth={handleChangeDesiredMonth}
              defaultDesiredTimeList={defaultDesiredTimeList}
              monthsToShow={monthsToShow}
              desiredDayList={desiredDayList}
            />
            )}
            <FormElementWithOneTextArea
              nameInput="consultationOrRequest"
              labelInput="ご相談・ご要望"
            />
            <FormElementWithCheckboxes
              nameInput="isEmailNewsLetter"
              labelInput="メルマガを希望する"
            />
            <AgreeSection setIsButtonNextDisable={setIsButtonNextDisable} note={note} />
            <Box display="flex" justifyContent="center" alignItems="center">
              <BigButtonNext type="submit" content={status === StatusBooking.CALL_BEFORE_BOOKING ? 'お問い合わせを送信' : '申し込む'} isDisabled={isButtonNextDisable} />
            </Box>
          </form>
        </FormProvider>
      </div>
    </ScreenLoader>
  );
};


export default EnterCustomerInformation;
